import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { Injectable } from '@angular/core';
import { EventEmitter } from 'events';

@Injectable()
export class LoyaltyProgramProvider {

  public customer: CustomerModel;
  public cardConnectEvent: EventEmitter;
  public sessionToken: string;
  private isAuthenticated: boolean = false;

  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService
  ) {

    this.cardConnectEvent = new EventEmitter();

    this.userSession.getCustomer().subscribe(customer => {
      this.customer = customer;
      this.sessionToken = this.userSession.getSessionToken();
    });
  }

  public connectLoyaltyCard(data: any) {
    if (this.customer) {
      const obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
        reward_number: data.loyalty_card_id,
      };

      return this.webservice.post("rewards/link-reward-card", obj);
    }
  }

  public getLoyaltyCard() {
    if (this.customer) {
      const obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken
      };
      return this.webservice.get("rewards/has-reward-card", obj);
    }
  }
}
